import { render } from "./BacNinh.vue?vue&type=template&id=6f9ca459&scoped=true"
import script from "./BacNinh.vue?vue&type=script&scoped=true&lang=js"
export * from "./BacNinh.vue?vue&type=script&scoped=true&lang=js"

import "./BacNinh.vue?vue&type=style&index=0&id=6f9ca459&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f9ca459"]])

export default __exports__